import { Body, Box, Container } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { DownloadAppModal } from '../../common';
import HoverMaterials from '../../../assets/videos/Hover_Materials.mp4';
import ArrowButton from '../../ui/ArrowButton';
import AccordionContent from './AccordionContent';
import ProductionHeader from './ProductionHeader';

interface Props {
  realTimeListItems: string[];
  orderDirectlyListItems: string[];
}

const ProductionMobile: React.FC<Props> = ({
  realTimeListItems,
  orderDirectlyListItems,
}) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const toggleModal = () => setIsOpenModal(!isOpenModal);

  return (
    <Box
      maxW="xl"
      mx={{ base: 'auto', desktop: 0 }}
      d={{ base: 'flex', desktop: 'none' }}
      flexDir="column"
      alignItems="flex-start"
      px={0}
    >
      <Container px={0}>
        <ProductionHeader />
        <DownloadAppModal isOpen={isOpenModal} onClose={toggleModal} />
        <Body size={600} isSemiBold mt={500} mb={200}>
          Direct Ordering
        </Body>
        <AccordionContent
          mb={700}
          listItems={realTimeListItems}
          body="Supplier direct ordering from the HOVER app makes everything simpler."
        />
        <Container px={500} maxW="lg">
          <StaticImage
            quality={100}
            placeholder="blurred"
            objectFit="contain"
            alt="real time 3d"
            src="../../../assets/images/exterior_contractor_simple_production_solution.png"
          />
        </Container>
      </Container>
      <Container px={0}>
        <Body size={600} isSemiBold mt="72px" mb={200}>
          Labor Management
        </Body>
        <AccordionContent
          mb={700}
          listItems={orderDirectlyListItems}
          body="With just a few clicks, meet every project's specific installation needs"
        />
        <Container px={500} maxW="lg">
          <video autoPlay src={HoverMaterials} muted playsInline />
        </Container>
        <Box flexDir={{ base: 'column', tablet: 'row' }} mt={800}>
          <Button mb={{ base: 500, desktop: 0 }} onClick={toggleModal}>
            Start measuring in 2 minutes
          </Button>
          <ArrowButton
            mb={{ base: 600, desktop: 0 }}
            variant="minimal"
            // TODO(buttons): remove when we remove padding in Blueprint
            sx={{ div: { pl: 100, pr: 50 } }}
            as={Link}
            to={`${process.env.GATSBY_V2_PREFIX}/pricing`}
          >
            Go to pricing
          </ArrowButton>
        </Box>
      </Container>
    </Box>
  );
};

export default ProductionMobile;
